export default __webpack_public_path__ + "static/become-a-star-illustration-dark-f9848413edb19d43c5a83db476ade1a3.svg";